import type { AnalyticsEventName } from '../../types/events';

export const PAYMENT_EVENTS = new Set<AnalyticsEventName>([
  'Check-out Shown',
  'Check-out Closed',
  'Check-out Started',
  'CC Payment Attempt',
  'Authorization_Start',
  'Authorization_Success',
  'Payment duration',
  'Payment Error',
  'Payment Init',
  'Payment Email Retrieved',
  'Upsell Check-out Shown',
  'Upsell Check-out Closed',
  'Upsale Purchase',
  'applepay_payment_method_selected',
  'applepay_syscheeckout_closed',
  'applepay_onpaymentauthorized_call',
  'applepay_auth_success',
  'applepay_auth_error',
  'googlepay_syscheeckout_closed',
]);
